import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Popper, Tooltip } from '@material-ui/core';
import { RoutingAllListNew, Images } from 'utils';

export const LeftBar = ({ handleDrawerClose, open }) => {
  const [isScrollable, setIsScrollable] = useState(false);
  const [isBottom, setIsBottom] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const { loadTotals } = useSelector((state) => ({
    loadTotals: state.loads.loadTotals,
  }));
  const history = useHistory();
  const mainRef = useRef(null);
  const timeoutRef = useRef(null);
  const creditCount = (loadTotals?.numCreditRequests ? loadTotals?.numCreditRequests : 0) + (loadTotals?.numConsignmentRequest ? loadTotals?.numConsignmentRequest : 0);
  const routingItems = RoutingAllListNew(creditCount);
  const { pathname } = history?.location;


  useEffect(() => {
    const checkScroll = () => {
      const container = mainRef.current;
      if (container) {
        const hasScroll = container.scrollHeight > container.clientHeight;
        setIsScrollable(hasScroll);
        setIsBottom(container.scrollTop + container.clientHeight >= container.scrollHeight - 10);
      }
    };

    const handleScroll = () => checkScroll();

    const container = mainRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
      checkScroll();
    }

    return () => container?.removeEventListener('scroll', handleScroll);
  }, []);


  useEffect(() => {
    const activeItem = routingItems?.find(item => item?.pathsList?.includes(pathname));
    if (activeItem && !currentItem) {
      setCurrentItem(activeItem);
      if (open) {
        setIsExpanded(true);
      }
    }
  }, [pathname]);


  const handleMouseEnter = (event, item) => {
    if (item?.list?.length && !open) {
      clearTimeout(timeoutRef.current);
      setCurrentItem(item);
      setAnchorEl(event.currentTarget);
    }
  };

  const handleMouseLeave = (item) => {
    if (item?.list?.length && !open) {
      timeoutRef.current = setTimeout(() => {
        setCurrentItem(null);
      }, 200);
    }
  };


  const goToPage = (item) => {
    if (!item?.list?.length) {
      history.push(`${item?.path}`);
      setIsExpanded(false);
      setCurrentItem(null);
    } else {
      setCurrentItem((prev) => (prev?.name === item?.name ? null : item));
      setIsExpanded(prev => open && item?.name === currentItem?.name ? !prev : !(!open));
    }
  };

  const scroll = () => {
    const container = mainRef.current;
    if (container) {
      container.scrollTo({
        top: isBottom ? 0 : container.scrollHeight,
        behavior: 'smooth',
      });
    }
  };


  return (
    <div className={`left-bar-new-wrapper ${!open ? 'left-bar-new-wrapper-closed' : ''}`}>
      <div className='left-bar-new-box'>
        <div style={{ height: 'calc(100% - 56px)' }}>
          <div
            className='left-bar-new-header'
            style={{
              maxWidth: open ? 1000 : 72,
              overflow: 'hidden',
            }}
          >
            <div className='left-bar-new-logo'>
              <img src={Images.logoWithoutText2} alt='logo' />
            </div>

            <p className='left-bar-new-title'>
              Polo X
            </p>
          </div>

          <div className='left-bar-new-main' ref={mainRef}>
            <div className='left-bar-new-items-wrapper'>
              {routingItems?.filter((item) => item)?.map((item, index) => (
                <button
                  key={index}
                  onMouseEnter={(e) => handleMouseEnter(e, item)}
                  onMouseLeave={() => handleMouseLeave(item)}
                  className={`left-bar-new-single_item-wrapper
               ${currentItem?.name === item?.name && isExpanded ? 'left-bar-new-single_item-wrapper-hovered' : ''}
                ${((item?.pathsList?.some((path) => pathname.startsWith(path))) || pathname.startsWith(item?.detail)) || item?.path === pathname ? 'left-bar-new-single_item-wrapper-selected' : ''}`}
                >
                  <div
                    className='left-bar-new-single_item-box'
                    onClick={() => goToPage(item)}
                    style={{
                      maxWidth: open ? 1000 : 0,
                      transition: 'all .2s',
                    }}
                  >
                    <div className='left-bar-new-single_item-icon_title'>
                      {item?.icon &&
                        <div className='left-bar-new-single_item-icon'>
                          <img src={item?.icon} alt='item icon' />
                        </div>
                      }

                      {item?.name &&
                        <p
                          className='left-bar-new-single_item-title'
                        >
                          {item?.name}
                        </p>
                      }

                      {!!item?.activeCount && open &&
                        <div className='eft-bar-new-single_item-lis-active-count'>
                          {item?.activeCount}
                        </div>
                      }
                    </div>

                    {((!!item?.list?.length && open)) &&
                      <div
                        className='left-bar-new-single_item-arrow-up'
                        style={{ transform: isExpanded && currentItem?.name === item?.name ? 'rotate(180deg)' : 'none' }}
                      >
                        <img src={Images.arrowUpSvg} alt='arrow up' />
                      </div>
                    }
                  </div>
                  <div
                    className={
                      `left-bar-new-single_item-list-wrapper ${(!!item?.list?.length && currentItem?.name === item?.name && isExpanded) ?
                        'left-bar-new-single_item-list-wrapper-active' : ''}`
                    }
                  >
                    {item?.list?.filter((item) => item)?.map((item, index) => (
                      <button
                        key={index}
                        className={`left-bar-new-single_item-list-box 
                        ${(pathname?.startsWith(item?.path) || pathname?.startsWith(item?.create) || pathname?.startsWith(item?.detail)) ?
                          'left-bar-new-single_item-list-box-active'
                          : 
                          ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          goToPage(item, true);
                        }}
                      >
                        {item?.name}

                        {!!item?.activeCount &&
                          <div className='eft-bar-new-single_item-lis-active-count'>
                            {item?.activeCount}
                          </div>
                        }
                      </button>
                    ))}
                  </div>

                  {(item?.name === currentItem?.name && !open) &&
                    <Popper
                      open={Boolean(anchorEl)}
                      anchorEl={anchorEl}
                      placement='right'
                      className='left-menu-popper-wrapper'
                      modifiers={{
                        offset: {
                          enabled: true,
                          offset: '0,10',
                        },
                        preventOverflow: {
                          enabled: true,
                          boundariesElement: 'viewport',
                        },
                      }}
                    >
                      <div
                        className={`left-bar-new-single_item-list-wrapper 
                      ${(!!item?.list?.length && currentItem?.name === item?.name) ? 'left-bar-new-single_item-list-wrapper-active' : ''}`}
                        onMouseEnter={() => clearTimeout(timeoutRef.current)}
                        onMouseLeave={() => handleMouseLeave(item)}
                      >
                        <div className='left-bar-new-single_item-list-arrow' />
                        <p className='left-menu-popper-title'>
                          {item?.name}
                        </p>
                        <div style={{ position: 'relative', zIndex: '22' }}>

                          {item?.list?.filter((item) => item)?.map((item, index) => (
                            <button
                              key={index}
                              className={`left-bar-new-single_item-list-box 
                              ${(pathname?.startsWith(item?.path) || pathname?.startsWith(item?.create) || pathname?.startsWith(item?.detail) || currentItem?.name === item?.name) ? 
                                'left-bar-new-single_item-list-box-active' 
                                : 
                                ''
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                goToPage(item);
                                setAnchorEl(null)
                              }}
                            >
                              {item?.name}

                              {!!item?.activeCount &&
                                <div className='eft-bar-new-single_item-lis-active-count'>
                                  {item?.activeCount}
                                </div>
                              }
                            </button>
                          ))}
                        </div>
                      </div>
                    </Popper>
                  }
                </button>
              ))}
            </div>
          </div>
        </div>

        {isScrollable && isBottom ?
          <button
            onClick={scroll}
            className='go-to-bottom-btn'
          >
            <img
              src={Images.arrowUpSvg} alt='arrow'
              style={{
                transform: !isBottom ? 'rotate(180deg)' : '',
              }}
            />
          </button>
          :
          open ?
            <div
              className='left-bar-new-footer'
              onClick={() => {
                setIsExpanded(!open ? !!currentItem : false);
                setAnchorEl(null);
                handleDrawerClose();
              }}
              style={{
                justifyContent: !open ? 'center' : '',
              }}
            >
              <div
                className='left-bar-new-opening-icon'
                style={{
                  transform: open ? 'rotate(180deg)' : '',
                }}
              >
                <img src={Images.openingLeftBar} alt='opening' />
              </div>
              {open &&
                <p className='left-bar-new-opening-text'>
                  Collapse
                </p>
              }
            </div>
            :
            <Tooltip
              title='Expand the Navigation'
              placement='right'
              arrow
              classes={{
                popper: 'expend-navigation-tooltip',
              }}
            >
              <div
                className='left-bar-new-footer'
                onClick={() => {
                  setIsExpanded(!open ? !!currentItem : false);
                  setAnchorEl(null);
                  handleDrawerClose();
                }}
                style={{
                  justifyContent: !open ? 'center' : '',
                }}
              >
                <div
                  className='left-bar-new-opening-icon'
                  style={{
                    transform: open ? 'rotate(180deg)' : '',
                  }}
                >
                  <img src={Images.openingLeftBar} alt='opening' />
                </div>
                {open &&
                  <p className='left-bar-new-opening-text'>
                    Collapse
                  </p>
                }
              </div>
            </Tooltip>
        }
      </div>
    </div>
  );
};

